<template>
    <div>
        <table style="margin: 20px 0 20px 0">

            <colgroup>
                <col width="20%" />
                <col width="20%" />
                <col width="20%" />
                <col width="20%" />
                <col width="20%" />
            </colgroup>

            <tr align="center" style="font-size: 600; background-color: #0e59cb">
                <td>组织名称</td>
                <td>姓名</td>
                <td>政治面貌</td>
                <td>职务</td>
                <td>照片</td>
            </tr>

            <tr align="center" v-for="(item, index) in dataList" :key="index">
                <td>{{ item.shzzmc}}</td>
                <td>{{ item.xm }}</td>
                <td>{{ item.zzmm }}</td>
                <td>{{ item.zw }}</td>
                <td>
                    <span v-if="item.zp">
                        <img :src="item.zp" alt="" />
                    </span>
                    <span v-else>
                        <img src="../../assets/images/img_null_headimg.png" alt="" />
                    </span>
                </td>
            </tr>

            <tr v-if="!dataList.length" align="center">
                <td colspan="6">暂无数据</td>
            </tr>
        </table>
        <div class="yema">
            <Pagination v-show="query.total > 0" :total="query.total" :limit.sync="query.pageSize"
                :currentPageSize="query.pageSize" :page.sync="query.pageNum" round="false"
                layout="total, sizes, prev, pager, next, jumper" @pagination="changeHeader" />
        </div>
    </div>
</template>
<script>

import api from "@/api/bzh.js";

export default {
    name: '',
    components: {},
    data() {
        return {
            dataList: [],
            query: {
                total: 0,
                pageNum: 1,
                pageSize: 4,
            },
        }
    },
    created() { },
    mounted() {
        this.getList();
    },
    watch: {},
    methods: {
        getList() {
            let params = {
                lx:19,
                ...this.query
            }
            api.sqxqwgList2(params).then(res => {            
                if (res.data.code == 200) {
                    this.dataList = res.data.data.list || [];
                    this.query.total = res.data.data.total;
                }
            })
        },
        changeHeader(val) {
            this.query.pageNum = val;
            this.getList();
        }
    }
};
</script>
<style lang='scss' scoped>
table {
    table-layout: fixed;
    width: 100%;
    margin: 0;
    color: #fff;
    border-spacing: 0;
}

table tr:nth-child(even) {
    //   background-color: #0f53a5;
}

table td {
    height: 39px;
    border: 1px solid #105db4;
}

table td img {
    width: 47px;
    height: 47px;
}

::v-deep .el-tabs {
    height: 500px !important;
}

.iconImg {
    position: relative;
    top: -2px;
    left: -2px;
    margin-right: 2px;
}
</style>